import { InjectionToken, Provider } from '@angular/core';

/**
 * Tenant/domain identification config consumed by `domainInterceptor`.
 *
 * `localHostName` is the hostname sent in the `referer-domain` header when the
 * runtime host resolves to `localhost` or a private network (`192.168.*`).
 * It mirrors the legacy `local_host_name` constant in `fb-shipper-frontend`'s
 * env configs and is required so the multi-tenant backend can route local-dev
 * requests to the correct tenant.
 */
export interface DomainConfig {
  readonly localHostName: string;
}

export const DOMAIN_CONFIG = new InjectionToken<DomainConfig>('DOMAIN_CONFIG');

export function provideDomainConfig(config: DomainConfig): Provider {
  return { provide: DOMAIN_CONFIG, useValue: config };
}
